export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          投稿爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          你有猛料？我们愿意听！欢迎吃瓜群众踊跃投稿
        </p>
        <div className="max-w-xl mx-auto bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8 text-center">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h3 className="font-heading text-lg text-foreground-950 mb-2">爆料投稿通道</h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-4">
            如果你有独家内幕、一手线报或娱乐圈最新动态，欢迎通过以下方式联系我们。爆料内容将严格保密，优质爆料一经采纳即享专属奖励。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm text-foreground-700 mb-5">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line text-primary-500"></i>
              <span>tiptop@91chigua.com</span>
            </span>
            <span className="hidden sm:block text-foreground-300">|</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-wechat-line text-primary-500"></i>
              <span>91chigua_tip</span>
            </span>
          </div>
          <a
            href="#hero"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            立即投稿
          </a>
        </div>
      </div>
    </section>
  );
}